import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

interface InvalidateEvaluationParams {
  documental_evaluation_id: number;
  comment: string;
}

@Injectable({ providedIn: "root" })
export class DocumentalEvaluationService {
  constructor(private http: HttpClientService) {}

  invalidateEvaluation({ documental_evaluation_id, comment }: InvalidateEvaluationParams): Observable<any> {
    const params = { comment };
    return this.http
      .delete(`/api/documental_evaluations/${documental_evaluation_id}`, { params })
      .pipe(tap((_) => console.log("DocumentalEvaluationService.invalidateEvaluation: Ok.")));
  }
}
